module.exports = __webpack_public_path__ + "img/ksu-back-new.519649a9.jpeg";